import React, { Component } from 'react';
import cx from 'classnames';

import s from './style';

import iconNedvex from 'assets/images/icons/type-filters/icon-nedvex.svg';
import iconNew from 'assets/images/icons/type-filters/icon-new.svg';
import iconBlacklist from 'assets/images/icons/type-filters/icon-blacklist.svg';
import { withTranslation } from 'react-i18next';

class FilterLabel extends Component {
  render() {
    const { isPopularList, index, isBlackList, isNew, isNedvex, t } = this.props;
    if (isPopularList) {
      return (
        <div className={s.FilterLabel}>
          <div className={cx(s.index, s[`index${index}`])}>{index}</div>
        </div>
      );
    }
    return (
      <div className={s.FilterLabel}>
        {!!isBlackList && (
          <div
            className={s.blackList}
            data-tip={t('components.buildings.filterLabel.blackList')}
            data-for="global"
          >
            <img src={iconBlacklist} alt="" />
          </div>
        )}
        {!!isNew && (
          <div className={s.new} data-tip={t('components.buildings.filterLabel.new')} data-for="global">
            <img src={iconNew} alt="" />
          </div>
        )}
        {!!isNedvex && !isNew && (
          <div className={s.nedvex} data-tip={t('components.buildings.filterLabel.nedvex')} data-for="global">
            <img src={iconNedvex} alt="" />
          </div>
        )}
      </div>
    );
  }
}

export default withTranslation()(FilterLabel);



// WEBPACK FOOTER //
// ./src/components/Buildings/FilterLabel/FilterLabel.js